import React, { useRef } from 'react';
import './BuyerUploads.scss';
import { Button, CardBody, CardHeader } from 'reactstrap';
import { BuyerUploadTile } from '../BuyerUploadTile/BuyerUploadTile';
import { useStateSelector } from '../../../../../store/selectors';
import createNotification from '../../../../../utils/createNotification';
import { GetBuyer } from '../../../../../slices/marketplace/buyer/thunks/get-buyer.thunk';
import { useDispatch } from 'react-redux';
import {
    MarketplaceBuyerUploadAccessLevel,
    MarketplaceBuyerUploadAccessLevelList,
} from '../../../../../slices/marketplace/buyer/models/buyer-upload';

export interface BuyerUploadsProps {
    accessLevel: MarketplaceBuyerUploadAccessLevel;
    isReadonly?: boolean;
}

export const BuyerUploads = (props: BuyerUploadsProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const profile = useStateSelector(
        (state) => state.buyersState.targetBuyer.profile
    );

    const uploadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            const pathByAccessLelel =
                MarketplaceBuyerUploadAccessLevelList.find(
                    (x) => x.id === props.accessLevel
                )?.name;
            axios
                .post(
                    `/api/Marketplace/MarketplaceBuyerUploads/${pathByAccessLelel}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                )
                .then((response) => {
                    if (response.status !== 200) {
                        const message = (response as any)?.response?.data
                            ?.detail;
                        createNotification(
                            message ??
                                'An error occurred while processing file',
                            'error'
                        );
                    }
                    fileInputRef.current.value = '';
                })
                .finally(() => {
                    fetchBuyerProfile();
                });
        }
    };
    const dispatch = useDispatch() as any;

    const fetchBuyerProfile = async () => {
        await dispatch(GetBuyer({ buyerId: null }));
    };

    const getInformationLabel = () => {
        return props.accessLevel ===
            MarketplaceBuyerUploadAccessLevel.Private ? (
            <label>
                All files uploaded here are viewable only by those sellers with
                whom you have an executed Data NDA.
            </label>
        ) : (
            <label>
                All files uploaded here can be viewed by potential sellers
                before any NDA is signed.
            </label>
        );
    };

    return (
        <div className="buyer-uploads">
            <CardBody className="buyer-body-header">
                {!props.isReadonly && (
                    <>
                        <Button
                            className="btn btn-primary upload-btn"
                            color="primary"
                            onClick={() => {
                                fileInputRef.current.click();
                            }}>
                            Upload
                        </Button>
                        <input
                            hidden={true}
                            ref={fileInputRef}
                            type="file"
                            name="file"
                            id="upload-file"
                            className="upload-file-input"
                            onChange={uploadFile}
                        />
                    </>
                )}
                {!props.isReadonly && getInformationLabel()}
                <div className="uploaded-files">
                    {profile.uploads
                        .filter((x) => x.accessLevel === props.accessLevel)
                        .map((upload) => (
                            <BuyerUploadTile
                                isReadonly={props.isReadonly}
                                upload={upload}></BuyerUploadTile>
                        ))}
                </div>
            </CardBody>
        </div>
    );
};
